import type { SVGProps } from 'react';

export const WorkShelfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' aria-hidden='true' {...props}>
    <path d='M4 3h4a2 2 0 0 1 2 2v14H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm8 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-8V5ZM5 7h2v2H5V7Zm10 0h4v2h-4V7Zm0 4h4v2h-4v-2Z' />
  </svg>
);
